(function () {
  'use strict';

  function DropDownSearch(cfg) {
    this.types = cfg.searchTypes;
    this.init();
  }
  DropDownSearch.prototype = {
    init: function init() {
      this.type = this.types[0];
      this.search = null;
    },
    select: function select(type) {
      this.type = type;
    }
  };
  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/search', {
      templateUrl: 'modules/app/data/search/search.html',
      controller: 'DataSearchCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).factory('StatementUtils', ['TinCanJS', function (TinCanJS) {
    var service = {};
    function scrub(stmt) {
      stmt.actor = scrubAgent(stmt.actor);
      stmt.verb = scrubAliasTarget(stmt.verb);
      stmt.object = scrubAliasTarget(stmt.object);
      stmt.authority = scrubAgent(stmt.authority);
      if (stmt.object.objectType === 'Agent' || stmt.object.objectType === 'Group') {
        stmt.object = scrubAgent(stmt.object);
      }
      if (stmt.context) {
        stmt.context.instructor = scrubAgent(stmt.context.instructor);
        stmt.context.team = scrubAgent(stmt.context.team);
        if (stmt.context.contextActivities) {
          var ctxActs = stmt.context.contextActivities;
          _.each(["parent", "grouping", "category", "other"], function (field) {
            if (ctxActs[field] && ctxActs[field].length) {
              ctxActs[field] = _.map(ctxActs[field], function (act) {
                return scrubAliasTarget(act);
              });
            }
          });
        }
      }
      return stmt;
    }
    function scrubAgent(agent) {
      if (!agent || !agent.groups) {
        return agent;
      }
      agent = _.extend({}, agent);
      delete agent.person;
      delete agent.groups;
      if (agent.member) {
        _.each(agent.member, function (member) {
          delete member.person;
          delete member.groups;
        });
      }
      return agent;
    }
    function scrubAliasTarget(target) {
      if (!target || !target.originalId) {
        return target;
      }
      delete target.originalId;
      return target;
    }
    service.processStatements = function (statements) {
      var original = {};
      var scrubbed = {};
      _.each(statements, function (stmt) {
        delete stmt.tenantId;
        delete stmt.actors;
        if (stmt.result && stmt.result.durationCentiseconds) {
          delete stmt.result.durationCentiseconds;
        }
        original[stmt.id] = angular.copy(stmt);
        // _extend is a shallow copy so the context will be shared with the scrubbed
        // version as well... thus when the scrubbed context is edited this one would be
        // too.  To avoid this, deep copy the context as-is.  We could deep copy the whole
        // statement but at least this way we get to preserve some of the object re-use between
        // the scrubbed and original statement versions.
        if (original[stmt.id].context) {
          original[stmt.id].context = angular.copy(original[stmt.id].context);
        }
        scrubbed[stmt.id] = scrub(angular.copy(stmt));
      });
      var decoratedStatements = TinCanJS.getDecoratedStatements(statements);
      return {
        decoratedStatements: decoratedStatements,
        original: original,
        scrubbed: scrubbed
      };
    };
    return service;
  }]).
  /**
   * Statement Viewer
  */
  controller('DataSearchCtrl', ['$http', '$routeParams', '$scope', '$timeout', 'Api', 'Interactions', 'TinCanJS', 'StatementUtils', '$location', function DataSearchCtrl($http, $routeParams, $scope, $timeout, Api, Interactions, TinCanJS, StatementUtils, $location) {
    $scope.section = "search";
    var searchUrl = Api.url('/interactions/search');
    var formPostHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    function isQuotedBy(text, quoteStr) {
      return text && text.trim().length > 1 && text.indexOf(quoteStr) === 0 && text.lastIndexOf(quoteStr) === text.length - quoteStr.length;
    }
    function escapeRegexpChars(text) {
      //escape any reserved regexp chars so they are treated as literals
      return text.replace(/(?=(\.|\?|\+|\*|\||\{|\}|\[|\]|\(|\)|\/|\"|\\|#|@|&|<|>|~))/g, '\\');
    }
    function searchValue(text) {
      if (!text || !text.trim().length) {
        return text;
      }
      if (isQuotedBy(text, "'") || isQuotedBy(text, '"')) {
        return text.substring(1, text.length - 1);
      }
      if (isQuotedBy(text, "/")) {
        return text;
      }
      return '/.*' + escapeRegexpChars(text) + '.*/';
    }
    function refreshData() {
      $scope.error = null;
      var cardFilter = null;
      try {
        cardFilter = JSON.parse($scope.editor.getValue());
      } catch (error) {
        if (error.name !== 'SyntaxError') {
          throw error;
        }
      }
      var agentSearch = $scope.agentSearch;
      var verbSearch = $scope.verbSearch;
      var activitySearch = $scope.activitySearch;
      var pagingInQuery = /\s+limit\s+/i.test($scope.query);
      var sortingInQuery = /\s+order\s+by\s+/i.test($scope.query);
      $scope.showPager = !pagingInQuery;
      var requestData = {
        'agent.name': agentSearch.type === 'name' ? searchValue(agentSearch.search) : null,
        'agent.mbox': agentSearch.type === 'mbox' ? searchValue(agentSearch.search) : null,
        'agent.account.homePage': agentSearch.type === 'account' ? searchValue($scope.agentAccountHomepage) : null,
        'agent.account.name': agentSearch.type === 'account' ? searchValue($scope.agentAccountName) : null,
        'verb.id': verbSearch.type === 'id' ? searchValue(verbSearch.search) : null,
        'verb.name': verbSearch.type === 'name' ? searchValue(verbSearch.search) : null,
        'activity.id': activitySearch.type === 'id' ? searchValue(activitySearch.search) : null,
        'activity.name': activitySearch.type === 'name' ? searchValue(activitySearch.search) : null,
        'activity.description': activitySearch.type === 'description' ? searchValue(activitySearch.search) : null,
        'dateField': sortingInQuery ? null : $scope.dateSearch.type,
        'since': $scope.since,
        'until': $scope.until,
        'id': $scope.statementId,
        'context.registration': $scope.registration,
        'relatedAgents': $scope.relatedAgents || null,
        'relatedActivities': $scope.relatedActivities || null,
        'format': $scope.format.type,
        'cardFilter': JSON.stringify(cardFilter),
        'query': $scope.query,
        'limit': pagingInQuery ? null : $scope.limit,
        'offset': pagingInQuery ? null : $scope.offset,
        'orderBy': sortingInQuery ? null : $scope.orderBy
      };

      // If using non-default format and getting statements direct from LRS, use originalId for
      // activity search to make sure aliasing doesn't get in the way
      if ($scope.format.type && $scope.format.type !== 'default' && requestData['activity.id']) {
        requestData['activity.originalId'] = requestData['activity.id'];
        delete requestData['activity.id'];
      }
      $scope.loading = true;
      return $http.post(searchUrl, $.param(requestData), {
        headers: formPostHeaders
      }).then(function success(response) {
        var rawStatements = response.data.results[0].result;
        var _StatementUtils$proce = StatementUtils.processStatements(rawStatements),
          decoratedStatements = _StatementUtils$proce.decoratedStatements,
          original = _StatementUtils$proce.original,
          scrubbed = _StatementUtils$proce.scrubbed;
        $scope.statements = decoratedStatements;
        $scope.original = original;
        $scope.scrubbed = scrubbed;
        $scope.count = response.data.totalHits;
        $scope.resultsDateType = $scope.dateSearch.type;
        $scope.loading = false;
        return {
          results: $scope.statements,
          count: $scope.count
        };
      }, function error(response) {
        $scope.error = response.data.message;
        $scope.statements = [];
        $scope.count = 0;
        $scope.loading = false;
        return {
          results: $scope.statements,
          count: $scope.count
        };
      });
    }
    $scope.agentSearch = new DropDownSearch({
      searchTypes: ['mbox', 'account', 'name']
    });
    $scope.verbSearch = new DropDownSearch({
      searchTypes: ['id', 'name']
    });
    $scope.activitySearch = new DropDownSearch({
      searchTypes: ['id', 'name', 'description']
    });
    $scope.dateSearch = new DropDownSearch({
      searchTypes: ['stored', 'timestamp']
    });
    $scope.format = new DropDownSearch({
      searchTypes: ['default', 'exact', 'ids', 'canonical']
    });
    var ctrlDown = false;
    $scope.keyDown = function (e) {
      if (e.keyCode === 91 || e.keyCode === 17) {
        ctrlDown = true;
      }
      if (ctrlDown && e.keyCode === 13) {
        $timeout(function () {
          $scope.refresh();
        });
      }
    };
    $scope.keyUp = function (e) {
      if (e.keyCode === 91 || e.keyCode === 17) {
        ctrlDown = false;
      }
    };
    $scope.checkQuerySyntax = function () {
      $scope.queryChecked = false;
      $scope.queryError = null;
      validateQuery();
    };

    // -------------------------------
    // Advanced Editor (ACE)
    // -------------------------------

    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
      _editor.setOptions({
        maxLines: 20,
        minLines: 2,
        highlightActiveLine: false
      });
    };
    var validateQuery = _.debounce($scope.$safeApply.bind($scope, function () {
      $scope.queryChecked = false;
      $scope.queryError = null;
      if ($scope.query.length === 0) {
        return;
      }
      $http.post(searchUrl + "/validate", $.param({
        query: $scope.query
      }), {
        headers: formPostHeaders
      }).then(function success() {
        $scope.queryChecked = true;
        $scope.queryError = null;
      }, function error(response) {
        $scope.queryChecked = true;
        $scope.queryError = response.data.message;
      });
    }), 500);
    $scope.fetchPage = function (offset, limit) {
      $scope.limit = limit;
      $scope.offset = offset;
      return refreshData();
    };
    $scope.refresh = function () {
      $scope.setPage(1);
    };

    // Allow query to be passed in via route params
    if ($routeParams.query) {
      $scope.query = $routeParams.query;
      $scope.checkQuerySyntax();
      $scope.showAdvanced = true;
    }
    $scope.onPagerLoad = function () {
      var dtOptions = {
          dateFormat: "yy-mm-dd",
          separator: "T",
          timeFormat: "HH:mm:ss.l",
          timeSuffix: "Z",
          pickerTimeFormat: "HH:mm:ss.l",
          pickerTimeSuffix: " Z",
          oneLine: true,
          showMillisec: true,
          showTimezone: false,
          alwaysSetTime: true
        },
        startOfDay = {
          hour: 0,
          minute: 0,
          second: 0,
          millisec: 0
        },
        endOfDay = {
          hour: 23,
          minute: 59,
          second: 59,
          millisec: 999
        };
      $("#since").datetimepicker($.extend({}, dtOptions, startOfDay));
      $("#until").datetimepicker($.extend({}, dtOptions, endOfDay));
      if ($location.search().filter) {
        $scope.editor.setValue($location.search().filter);
      }
      $scope.refresh();
    };
  }]);
})();
